import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

interface FilterDateProps {
  readonly StartDate: string;
  readonly EndDate: string;
  readonly onStartDateChange: (value: string) => void;
  readonly onEndDateChange: (value: string) => void;
}

export function FilterDate({ StartDate, EndDate, onStartDateChange, onEndDateChange }: FilterDateProps) {
  const handleStartDateChange = (newDate: Date | null) => {
    if (newDate) {
      const newStartDate = newDate.toISOString();
      
      if (EndDate && new Date(newStartDate) > new Date(EndDate)) {
        return;
      }
      
      onStartDateChange(newStartDate);
    }
  };

  const handleEndDateChange = (newDate: Date | null) => {
    if (newDate) {
      const newEndDate = newDate.toISOString();
      
      if (StartDate && new Date(newEndDate) < new Date(StartDate)) {
        return;
      }
      
      onEndDateChange(newEndDate);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <FormControl variant="standard" style={{ marginRight: '10px' }}>
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <DateTimePicker
            label="Fecha Inicio"
            value={StartDate ? new Date(StartDate) : null}
            onChange={handleStartDateChange}
            views={['year', 'month', 'day']}
            sx={{ marginRight: '10px' }}
            maxDate={EndDate ? new Date(EndDate) : undefined}
            slotProps={{
              textField: {
                required: Boolean(EndDate),
                error: Boolean(
                  (StartDate && EndDate && new Date(StartDate) > new Date(EndDate)) ||
                  (EndDate && !StartDate)
                ),
                helperText: StartDate && EndDate && new Date(StartDate) > new Date(EndDate) 
                  ? 'La fecha de inicio no puede ser mayor que la fecha fin' 
                  : EndDate && !StartDate 
                  ? 'Requerido cuando hay fecha fin' 
                  : ''
              }
            }}
          />
          <br />
          <DateTimePicker
            label="Fecha Fin"
            value={EndDate ? new Date(EndDate) : null}
            onChange={handleEndDateChange}
            views={['year', 'month', 'day']}
            minDate={StartDate ? new Date(StartDate) : undefined}
            slotProps={{
              textField: {
                required: Boolean(StartDate),
                error: Boolean(
                  (StartDate && EndDate && new Date(EndDate) < new Date(StartDate)) ||
                  (StartDate && !EndDate)
                ),
                helperText: StartDate && EndDate && new Date(EndDate) < new Date(StartDate) 
                  ? 'La fecha fin no puede ser menor que la fecha de inicio' 
                  : StartDate && !EndDate 
                  ? 'Requerido cuando hay fecha de inicio' 
                  : ''
              }
            }}
          />
        </Box>
      </FormControl>
    </LocalizationProvider>
  );
}
